import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import SectionTitleComponent from '@components/sectionTitle/SectionTitle'

const SectionTitlesSection = () => {
  return (
    <Section>
      <SectionTitle>Section Titles</SectionTitle>
      <Container>
        <SectionTitleComponent title="Title" />
      </Container>
      <Container>
        <SectionTitleComponent title="Title" button={{ label: 'Label', onClick: () => undefined }} />
      </Container>
    </Section>
  )
}

export default SectionTitlesSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const Container = styled(View)`
  margin-bottom: 12px;
`
